{
  "default": "creditreform-logo.jpg",
  "locations": {
    "217": "cr-logo-text-hameln-small.jpg",
    "225": "cr-logo-text-leer-small.jpg",
    "237": "cr-logo-text-oldenburg-small.jpg",
    "413": "cr-logo-text-guetersloh-small.jpg",
    "429": "cr-logo-text-paderborn-small.jpg"
  }
}
